import React, { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

function AddArticleModal({ isOpen, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    date: "",
    category: "",
    title: "",
    content: "",
    link: "",
    thumbnail: null
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      thumbnail: e.target.files[0]
    }));
  };

  // 블로그 링크에서 마지막 숫자 추출하는 함수
  const extractImageNameFromLink = (link) => {
    const match = link.match(/\/(\d+)$/);
    return match ? match[1] : null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = Cookies.get("token");
      const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

      // 블로그 링크에서 이미지 파일명 추출
      const imageFileName = extractImageNameFromLink(formData.link);
      if (!imageFileName) {
        alert("블로그 링크에서 이미지 파일명을 추출할 수 없습니다. 링크 형식을 확인해주세요.");
        setLoading(false);
        return;
      }

      // 텍스트 데이터 먼저 전송
      const textResponse = await axios.post("https://co77iri.com/adminAdd", {
        date: formData.date,
        category: formData.category,
        title: formData.title,
        content: formData.content,
        link: formData.link
      }, {
        headers: authHeaders
      });

      // 이미지 파일 전송 (블로그 링크의 마지막 숫자를 파일명으로 사용, PNG로 변환)
      if (formData.thumbnail) {
        const imageFormData = new FormData();
        const finalFileName = `${imageFileName}.png`;
        
        // 파일명을 PNG로 지정해서 FormData에 추가
        imageFormData.append("thumbnail", formData.thumbnail, finalFileName);
        imageFormData.append("imageKey", imageFileName);

        await axios.post("https://co77iri.com/adminAddImage", imageFormData, {
          headers: authHeaders
        });
      }

      alert("게시글이 성공적으로 추가되었습니다!");
      onSuccess();
      onClose();
      setFormData({
        date: "",
        category: "",
        title: "",
        content: "",
        link: "",
        thumbnail: null
      });
    } catch (error) {
      console.error("게시글 추가 실패:", error);
      alert("게시글 추가에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">게시글 추가</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                날짜
              </label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleInputChange}
                required
                pattern="\d{4}-\d{2}-\d{2}"
                placeholder="YYYY-MM-DD"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                분류
              </label>
              <select
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">분류 선택</option>
                <option value="교육">교육</option>
                <option value="기획">기획</option>
                <option value="제작">제작</option>
                <option value="로컬">로컬</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              제목
            </label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              내용
            </label>
            <textarea
              name="content"
              value={formData.content}
              onChange={handleInputChange}
              required
              rows="4"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              링크
            </label>
            <input
              type="url"
              name="link"
              value={formData.link}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              썸네일 이미지
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
            >
              취소
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
            >
              {loading ? "추가 중..." : "추가"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddArticleModal; 